<template lang="pug">
.c-files-editor
  v-form(ref="form"
    v-model="valid")
    v-btn(color="info" @click="$refs.input.click()") 選擇檔案
    v-dialog(v-model="alert")
      v-card
        v-card-text.error--text.text-xs-center.title 最多上傳10個檔案
        v-card-actions
          v-spacer
          v-btn(@click="alert = false") 確認
          v-spacer
    input.d-none(ref="input"
      type="file"
      multiple
      @change="uploadFiles")
    dnd(:value="items"
      handle=".handle"
      @input="updateItems")
      v-layout(v-for="(item, index) in items")
        v-avatar.mx-1(size="32")
          div.title {{ index + 1 }}
        v-text-field(v-model="item.title"
          :rules="[v => !!v || '請填寫檔案名稱']"
          label="檔案名稱"
          required)
        v-btn(:ripple="false"
          icon
          flat
          @click.stop="")
          v-icon.handle drag_handle
        v-btn(icon
          flat
          @click.stop="deleteItem(index)")
          v-icon.handle delete
</template>

<script>
import Dnd from "vuedraggable";

export default {
  name: "FilesEditor",
  components: {
    Dnd
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      valid: false,
      limit: 10,
      alert: false,
      innerItems: []
    };
  },
  watch: {
    items: {
      handler(val) {
        this.innerItems = val;
      },
      immediate: true
    }
  },
  methods: {
    deleteItem(index) {
      this.$emit("delete", index);
    },
    updateItems(v) {
      this.$emit("update", v || []);
    },
    uploadFiles(e) {
      const input = e.target;
      const result = JSON.parse(JSON.stringify(this.innerItems));

      if (this.innerItems.length + input.files.length < this.limit + 1) {
        for (let file of input.files) {
          const title = file.name.replace(/\..+$/, "");
          result.push({ file, title });
        }
        this.$emit("upload", result);
      } else {
        this.alert = true;
      }
    },
    validate() {
      return this.$refs.form.validate();
    }
  }
};
</script>
